import { DotsHorizontalIcon } from '@heroicons/react/outline';
import clsx from 'clsx';

import { Note } from '@/components/PdfReader/GeneratePdf/NotePdfDocument';
import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';
import { ShouldRender } from '@/components/shared/basic/ShouldRender';
import { generateAndDownloadPdf } from '@/components/shared/generateAndDownloadPdf';

interface NotesDrawerProps {
  notes: Record<string, Note[]>;
  onNoteSelect: (note: Note) => void;
  landingPageUrl: string;
  bookTitle?: string;
  bookAuthor?: string;
  isFullScreen?: boolean;
}

const NotesDrawer = ({
  notes,
  onNoteSelect,
  landingPageUrl,
  bookTitle,
  bookAuthor,
  isFullScreen,
}: NotesDrawerProps) => {
  const allNotes = Object.values(notes).flat();
  const handleDownload = () =>
    generateAndDownloadPdf({
      notes: Object.values(notes)
        .flat()
        .map((note) => ({
          ...note,
        })),
      title: bookTitle || 'Zebralearn Book Notes',
      author: bookAuthor || 'Zebralearn',
      landingPageUrl: landingPageUrl,
    });
  return (
    <div className='grid md:grid-cols-2 gap-4 p-6 hide-scrollbar'>
      {allNotes.map((note) => (
        <div
          key={note.id}
          className='cursor-pointer hide-scrollbar h-full'
          onClick={() => onNoteSelect(note)}
        >
          <div className='flex flex-col items-end gap-4 self-stretch py-3 px-4 rounded-[10px] bg-cartBgColor  h-full'>
            <div className='flex items-start gap-3 self-stretch justify-between'>
              <div className='flex flex-col justify-center items-start'>
                <div className='text-grayZl-500 text-center font-thin text-sm leading-[1.375rem]'>
                  {note.chapter}
                </div>
                <div className='text-grayZl-600 text-center  text-[10px] leading-[1.125rem]'>
                  {note.date}
                </div>
              </div>
              <div className='text-white text-center font-thin leading-6'>
                {note.pageNumber}
              </div>
            </div>
            <div className='flex justify-start w-full bg-[#FF56124D]'>
              <p className='line-clamp-2 text-white text-sm leading-[1.375rem]  italic text-white/70 '>
                {`“${note.excerpt}” `}
              </p>
            </div>

            <div className='flex flex-col items-stretch justify-between h-full w-full gap-3 '>
              <p className='line-clamp-3 text-white text-sm leading-[1.375rem]'>
                {note.content}
              </p>
              <div className='flex justify-end items-center gap-2 self-stretch'>
                <DotsHorizontalIcon className='w-5 h-5 text-white' />
              </div>
            </div>
          </div>
        </div>
      ))}
      <ShouldRender check={!isFullScreen}>
        <div
          className={clsx('fixed md:hidden bottom-0 left-0', 'w-full lg:pb-5')}
        >
          <div className='bg-bgColor border-t-[1px] lg:border-none border-[#2A2A2A] md:px-6 items-center translate-y-1 p-2 xs:p-3 lg:p-0  flex'>
            <ButtonDefault
              size={2}
              onClick={handleDownload}
              variant={ButtonVariants.WHITE}
              className='w-full  whitespace-nowrap'
            >
              <div className='py- px-4'>Download as PDF</div>
            </ButtonDefault>
          </div>
        </div>
      </ShouldRender>
    </div>
  );
};

export default NotesDrawer;
